import { useLang } from "../../lib/LangContext";
import { SectionHeader } from "./SectionHeader";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

// Prices are under review (P2.1): hide FAQ answers that quote amounts.
const PRICE_RE = /\d\s?€|€\s?\d/;

export const FAQ = () => {
  const { t } = useLang();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-[#070708]"
    >
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <SectionHeader
          eyebrow={t.faq.eyebrow}
          title={t.faq.title}
          align="center"
          testid="faq-header"
        />

        <Accordion type="single" collapsible className="mt-16 w-full">
          {t.faq.items.filter((i) => !PRICE_RE.test(i.a)).map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="border-white/10"
            >
              <AccordionTrigger className="text-left text-white text-base md:text-lg font-medium hover:text-gold py-6 [&[data-state=open]]:text-gold">
                <span className="flex items-center gap-4">
                  <span className="text-gold text-xs tracking-[0.25em] font-mono">{String(idx + 1).padStart(2, "0")}</span>
                  {item.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-base leading-relaxed pl-10 pr-4 pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
